import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LangMenu from "../LangMenu";
import Faq from "../Faq";
import { V2Footer } from "./V2Home";

export default function FaqPage() {
  return (
    <div data-testid="faq-page" className="v2-modern bg-[#FAF9F6] text-[#1A1B18] min-h-screen flex flex-col">
      <header data-testid="faq-header" className="border-b border-[#1A1B18]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex items-center justify-between">
          <Link to="/" data-testid="faq-logo" className="font-modern text-xl md:text-2xl font-semibold tracking-tight">
            Stylottica Ceglie
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to="/"
              data-testid="faq-back-home"
              className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#1A1B18]/60 hover:text-[#A86946] transition-colors"
            >
              <ArrowLeft size={14} /> Home
            </Link>
            <LangMenu />
          </div>
        </div>
      </header>
      <main className="flex-1">
        <Faq modern />
      </main>
      <V2Footer />
    </div>
  );
}
